var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SurveyFrontEnd',{style:(_vm.themeColor),attrs:{"type":"result","title":_vm.title,"content":_vm.content,"btn-text":_vm.btnText,"image-src":_vm.imageSrc,"btn-url":_vm.btnUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }